webpackJsonp([35783957827783],{

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'Hero' },
	    _react2.default.createElement(
	      'div',
	      { className: 'HeroGroup' },
	      _react2.default.createElement(
	        'p',
	        null,
	        'Welcome to'
	      ),
	      _react2.default.createElement(
	        'h1',
	        null,
	        'AI Gender Bias',
	        _react2.default.createElement('br', null),
	        'Education Program'
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/0-introduction/' },
	        'Instructions'
	      )
	    )
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-371595a27223f4a34da6.js